import { all, fork } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import test, { testSaga } from 'store/modules/test';
import app, { appSaga } from 'store/modules/app';
import base, { baseSaga } from 'store/modules/base';
import auth, { authSaga } from 'store/modules/auth';
import util, { utilSaga } from 'store/modules/util';
import user, { userSaga } from 'store/modules/user';
import employee, { employeeSaga } from 'store/modules/employee';
import notification, { notificationSaga } from 'store/modules/notification';
import dashboard, { dashboardSaga } from 'store/modules/dashboard';
import partner, { partnerSaga } from 'store/modules/partner';
import invoice, { invoiceSaga } from 'store/modules/invoice';

import project, { projectSaga } from 'store/modules/project';
import bin, { binSaga } from 'store/modules/bin';
import file, { fileSaga } from 'store/modules/file';
import unit, { unitSaga } from 'store/modules/unit';
import support, { supportSaga } from 'store/modules/support';
import store, { storeSaga } from 'store/modules/store';
import serial, { serialSaga } from 'store/modules/serial';
import statistics, { statisticsSaga } from 'store/modules/statistics';
import patient, { patientSaga } from 'store/modules/patient';
import pms, { pmsSaga } from 'store/modules/pms';

export const rootReducer = combineReducers({
  test,
  app,
  base,
  auth,
  util,
  user,
  employee,
  notification,
  dashboard,
  partner,
  invoice,
  project,
  bin,
  file,
  unit,
  support,
  store,
  serial,
  statistics,
  patient,
  pms,
});

export function* rootSaga() {
  yield all([
    fork(testSaga),
    fork(appSaga),
    fork(baseSaga),
    fork(authSaga),
    fork(utilSaga),
    fork(userSaga),
    fork(employeeSaga),
    fork(notificationSaga),
    fork(dashboardSaga),
    fork(partnerSaga),
    fork(invoiceSaga),
    fork(projectSaga),
    fork(binSaga),
    fork(fileSaga),
    fork(unitSaga),
    fork(supportSaga),
    fork(storeSaga),
    fork(serialSaga),
    fork(statisticsSaga),
    fork(patientSaga),
    fork(pmsSaga),
  ]);
}

export default rootReducer;
